import { render, staticRenderFns } from "./question-timeRule.vue?vue&type=template&id=c62f8396&scoped=true&"
import script from "./question-timeRule.vue?vue&type=script&lang=js&"
export * from "./question-timeRule.vue?vue&type=script&lang=js&"
import style0 from "./question-timeRule.vue?vue&type=style&index=0&id=c62f8396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62f8396",
  null
  
)

export default component.exports